import { Component, OnInit, Input } from '@angular/core';

import { UiFactory } from '../../core/ui/ui-factory';
import { BadgeModel } from './badge-model';

@Component({
  selector: 'pg-badge-factory, grit-badge-factory',
  templateUrl: './pg-badge-factory.component.html',
  styleUrls: ['./pg-badge-factory.component.scss'],
})
export class PgBadgeFactoryComponent extends UiFactory {
  @Input() model;

  get badgeModel(): BadgeModel {
    return this.model;
  }
}
